"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../");
var logo_adminPortal_svg_1 = __importDefault(require("../../assets/images/logo-adminPortal.svg"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var mq_1 = require("../../utils/styled/mq");
var SidePad_1 = require("./SidePad");
var SideToolbox_1 = require("./SideToolbox");
var LayoutContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var SidePadContainer = styled_components_1.default.div.attrs({
    className: 'tws-content-container',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\theight: auto;\n\tvertical-align: middle;\n\ttext-align: left;\n\tpadding: ", ";\n\tposition: relative;\n\t", "\n\n\t", "\n"], ["\n\theight: auto;\n\tvertical-align: middle;\n\ttext-align: left;\n\tpadding: ", ";\n\tposition: relative;\n\t", "\n\n\t", "\n"])), globalVars_module_scss_1.default.spacing0, function (props) {
    return props.hasSidePad
        ? "padding-top: 35px;\n\t\twidth: calc(100% - 280px);\n\t\t.tws-main-container {\n\t\t\twidth: 80%;\n\t\t\tmax-width: 1250px;\n\t\t}\n\t\t"
        : "margin: 0 auto;\n\t\tpadding-top: 35px;\n\t\tpadding-bottom: 35px;\n\t\twidth: 84%;\n\t\tmax-width: 1300px;";
}, (0, mq_1.lessThan)('large')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\twidth: calc(100% - 30px);\n\t"], ["\n\t\twidth: calc(100% - 30px);\n\t"]))));
SidePadContainer.displayName = 'SidePadContainer';
var InfoBarRightContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmargin-left: auto;\n\tdisplay: inline-flex;\n"], ["\n\tmargin-left: auto;\n\tdisplay: inline-flex;\n"])));
InfoBarRightContainer.displayName = 'InfoBarRightContainer';
var InfoBarDivider = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\twidth: 1px;\n\tborder-left: ", " ", " ", ";\n\theight: 40px;\n\tmargin: 0 15px;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\theight: 32px;\n\t}\n"], ["\n\twidth: 1px;\n\tborder-left: ", " ", " ", ";\n\theight: 40px;\n\tmargin: 0 15px;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\theight: 32px;\n\t}\n"])), globalVars_module_scss_1.default.borderThin, globalVars_module_scss_1.default.borderSolid, globalVars_module_scss_1.default.secondaryGray2);
InfoBarDivider.displayName = 'InfoBarDivider';
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showSidePad: false,
        };
        _this.toggleSidePad = _this.toggleSidePad.bind(_this);
        return _this;
    }
    Layout.prototype.render = function () {
        var _a = this.props, applicationLogoProps = _a.applicationLogoProps, children = _a.children, clientLogoProps = _a.clientLogoProps, domainName = _a.domainName, footerProps = _a.footerProps, headerProps = _a.headerProps, infoBarContent = _a.infoBarContent, infoBarProps = _a.infoBarProps, mainContentProps = _a.mainContentProps, sidePad = _a.sidePad, sidePadProps = _a.sidePadProps, sideToolbox = _a.sideToolbox, impersonationCard = _a.impersonationCard, clientContextSelector = _a.clientContextSelector, userMenu = _a.userMenu;
        return (React.createElement(LayoutContainer, null,
            React.createElement(__1.Header, __assign({}, headerProps)),
            React.createElement(__1.InfoBar, __assign({}, infoBarProps), infoBarContent ? (infoBarContent()) : (React.createElement(React.Fragment, null,
                React.createElement(__1.ApplicationLogo, __assign({ logoSrc: logo_adminPortal_svg_1.default, mobileLogoSrc: logo_adminPortal_svg_1.default }, applicationLogoProps)),
                ((clientLogoProps === null || clientLogoProps === void 0 ? void 0 : clientLogoProps.logoSrc) || (clientLogoProps === null || clientLogoProps === void 0 ? void 0 : clientLogoProps.displayText)) && React.createElement(__1.ClientLogo, __assign({}, clientLogoProps)),
                clientContextSelector && clientContextSelector(),
                React.createElement(InfoBarRightContainer, null,
                    impersonationCard && impersonationCard(),
                    impersonationCard && userMenu && React.createElement(InfoBarDivider, null),
                    userMenu && userMenu())))),
            React.createElement(SidePadContainer, { hasSidePad: sidePad },
                React.createElement(__1.MainContent, __assign({}, mainContentProps, { margin: '0 auto', width: '100%' }),
                    children,
                    sideToolbox && React.createElement(SideToolbox_1.SideToolbox, { hasSidePad: sidePad }, sideToolbox())),
                sidePad && (React.createElement(React.Fragment, null,
                    React.createElement(SidePad_1.SidePad, { visible: this.state.showSidePad },
                        React.createElement(SidePad_1.Header, null,
                            (sidePadProps === null || sidePadProps === void 0 ? void 0 : sidePadProps.headerText) || '',
                            React.createElement("span", { onClick: this.toggleSidePad },
                                React.createElement(__1.Icon, { name: 'angle-right' }))),
                        React.createElement(SidePad_1.Body, null,
                            (sidePadProps === null || sidePadProps === void 0 ? void 0 : sidePadProps.titleText) && React.createElement(SidePad_1.Title, null, sidePadProps.titleText),
                            sidePad())),
                    React.createElement(SidePad_1.SidePadClosed, { visible: !this.state.showSidePad, onClick: this.toggleSidePad },
                        React.createElement(__1.Icon, { name: 'angle-left' }))))),
            React.createElement(__1.Footer, __assign({}, footerProps, { domainName: domainName }))));
    };
    Layout.prototype.toggleSidePad = function () {
        this.setState({ showSidePad: !this.state.showSidePad });
    };
    // Default props
    Layout.defaultProps = {
        headerProps: {},
        infoBarProps: {},
        applicationLogoProps: {},
        clientLogoProps: {},
        mainContentProps: {},
        footerProps: {},
        sidePadProps: {},
    };
    return Layout;
}(React.Component));
exports.Layout = Layout;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
